/**
 * ポップアップ機能の初期化
 * ページ読み込み後4秒後にポップアップを表示
 * 一度表示したら24時間は再表示しない
 */
const popup = () => {
  const popupElement = document.querySelector('.js-popup');
  if (!popupElement) {
    return;
  }

  const backdrop = popupElement.querySelector('.m-popup__backdrop');
  const closeButton = popupElement.querySelector('.m-popup__close');
  const visibleClass = 'is-visible';
  const delayTime = 4000; // 4秒
  const cacheKey = 'popup_shown';
  const cacheDuration = 24 * 60 * 60 * 1000; // 24時間（ミリ秒）

  // キャッシュをチェックする関数
  const shouldShowPopup = () => {
    const cachedTime = localStorage.getItem(cacheKey);
    if (!cachedTime) {
      return true; // キャッシュがない場合は表示
    }

    const now = Date.now();
    const cachedTimestamp = parseInt(cachedTime, 10);
    const timeDiff = now - cachedTimestamp;

    // 24時間経過していれば表示
    return timeDiff >= cacheDuration;
  };

  // キャッシュに記録する関数
  const savePopupShown = () => {
    localStorage.setItem(cacheKey, Date.now().toString());
  };

  // ポップアップを表示する関数
  const showPopup = () => {
    popupElement.classList.add(visibleClass);
    // スクロールを無効化
    document.body.style.overflow = 'hidden';
    // 表示した時刻をキャッシュに記録
    savePopupShown();
  };

  // ポップアップを非表示にする関数
  const hidePopup = () => {
    popupElement.classList.remove(visibleClass);
    // スクロールを有効化
    document.body.style.overflow = '';
  };

  // バックドロップをクリックした時の処理
  if (backdrop) {
    backdrop.addEventListener('click', (e) => {
      // バックドロップ自体がクリックされた場合のみ閉じる
      if (e.target === backdrop) {
        hidePopup();
      }
    });
  }

  // 閉じるボタンをクリックした時の処理
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      hidePopup();
    });
  }

  // ESCキーで閉じる
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popupElement.classList.contains(visibleClass)) {
      hidePopup();
    }
  });

  // キャッシュをチェックして、表示すべき場合のみ4秒後に表示
  if (shouldShowPopup()) {
    setTimeout(() => {
      showPopup();
    }, delayTime);
  }
};

export { popup };
